const typography = {
  '.type-h1': {
    base: {
      fontSize: '44px',
      lineHeight: '44px',
      letterSpacing: -1.25,
      fontWeight: 'normal',
    },
    md: {
      fontSize: '49px',
      lineHeight: '49px',
    },
  },
  '.type-h2': {
    base: {
      fontSize: '39px',
      lineHeight: '44px',
      letterSpacing: -1,
      fontWeight: 'normal',
    },
    md: {
      fontSize: '44px',
    },
  },
  '.type-h3': {
    base: {
      fontSize: '35px',
      lineHeight: '39px',
      letterSpacing: -1,
      fontWeight: 'normal',
    },
    md: {
      fontSize: '39px',
    },
  },
  '.type-h4': {
    base: {
      fontSize: '31px',
      lineHeight: '35px',
      letterSpacing: -1,
      fontWeight: 'normal',
    },
    md: {
      fontSize: '35px',
    },
  },
  '.type-h5': {
    base: {
      fontSize: '27px',
      lineHeight: '31px',
      letterSpacing: 0.5,
      fontWeight: 'normal',
    },
    md: {
      fontSize: '31px',
    },
    lg: {
      letterSpacing: -0.5,
    },
  },
  '.type-h6': {
    base: {
      fontSize: '24px',
      lineHeight: '27px',
      letterSpacing: 0.5,
      fontWeight: 'normal',
    },
    md: {
      fontSize: '27px',
    },
  },
  '.type-h7': {
    base: {
      fontSize: '24px',
      lineHeight: '24px',
      letterSpacing: -0.25,
      fontWeight: 'normal',
    },
  },
  '.type-body-2xl': {
    base: {
      fontSize: '22px',
      lineHeight: '22px',
      letterSpacing: 0,
      fontWeight: 'normal',
    },
  },
  '.type-body-xl': {
    base: {
      fontSize: '19px',
      lineHeight: '19px',
      letterSpacing: 0,
      fontWeight: 'normal',
    },
  },
  '.type-body-lg': {
    base: {
      fontSize: '17px',
      lineHeight: '17px',
      letterSpacing: 0,
      fontWeight: 'normal',
    },
  },
  '.type-body': {
    base: {
      fontSize: '15px',
      lineHeight: '15px',
      letterSpacing: 0,
      fontWeight: 'normal',
    },
  },
  '.type-body-sm': {
    base: {
      fontSize: '14px',
      lineHeight: '14px',
      letterSpacing: 0,
      fontWeight: 'normal',
    },
  },
  '.type-body-xs': {
    base: {
      fontSize: '13px',
      lineHeight: '13px',
      letterSpacing: 0,
      fontWeight: 'normal',
    },
  },
  '.type-body-2xs': {
    base: {
      fontSize: '12px',
      lineHeight: '12px',
      letterSpacing: 0,
      fontWeight: 'normal',
    },
  },
  '.type-eyebrow': {
    base: {
      fontSize: '11px',
      lineHeight: '11px',
      letterSpacing: 0,
      fontWeight: 'normal',
    },
  },
  '.type-eyebrow-sm': {
    base: {
      fontSize: '9px',
      lineHeight: '9px',
      letterSpacing: 0,
      fontWeight: 'normal',
    },
  },
  '.type-tiny': {
    base: {
      fontSize: '8px',
      lineHeight: '8px',
      letterSpacing: 0,
      fontWeight: 'normal',
    },
  },
};

export default typography;
